import { InjectionToken } from '@angular/core';

import { AvTelemetryEnvelope } from './av-telemetry.model';

export interface AvTelemetryBufferRow {
  id?: number;
  deviceCode: string;
  expiresAt: number;
  bytes: number;
  envelope: AvTelemetryEnvelope;
}

export interface AvTelemetryMetricAggregate {
  avg: number;
  min: number;
  max: number;
}

export interface AvTelemetryBufferConfig {
  ttlMs: number;
  maxBytes: number;
  flushIntervalMs: number;
  collapseWindowMs: number;
}

/** Must over-estimate the largest row: below maxBytes/this many rows the cap is not checked. */
export const AV_TELEMETRY_MAX_EXPECTED_ROW_BYTES = 6_000;

export const AV_TELEMETRY_BUFFER_DEFAULTS: AvTelemetryBufferConfig = {
  // A signing cannot be rejoined from a previous day's schedule.
  ttlMs: 24 * 60 * 60 * 1_000,
  maxBytes: 10 * 1024 * 1024,
  flushIntervalMs: 60_000,
  collapseWindowMs: 10_000,
};

export const AV_TELEMETRY_BUFFER_CONFIG = new InjectionToken<AvTelemetryBufferConfig>(
  'AV_TELEMETRY_BUFFER_CONFIG',
  { factory: () => AV_TELEMETRY_BUFFER_DEFAULTS }
);
